import ReactGA from 'react-ga4';
// import ReactGA from 'react-ga';
import { TRACKING_ID } from '../define/global';

// function init() {
//   // Enable debug mode on the local development environment
//   ReactGA.initialize(TRACKING_ID, { debug: false });
// }

// //Event Function Overloading
// const preEvent = ReactGA.event;
// ReactGA.event = (payload) => {
//   preEvent(payload);
// };

// const prePageView = ReactGA.pageview;
// ReactGA.pageview = (payload) => {
//   prePageView(payload);
// };

// export default ReactGA;
// export { init };

function init() {
  ReactGA.initialize(TRACKING_ID);
}

//Event Function Overloading
const preEvent = ReactGA.event;
ReactGA.event = (payload) => {
  const newPayload = {
    ...payload,
    action: payload.category,
    category: payload.action
  };
  preEvent(newPayload);
};

const preSend = ReactGA.send;
ReactGA.send = (payload) => {
  preSend(payload);
};

export default ReactGA;
export { init };
